import { useCallback } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import PublicForms from './PublicForms';
import { canAccessPublicForms, PUBLIC_FORMS_PATH, publicFormsFallbackPath } from '../utils/publicFormsAccess';

const PublicFormsRoute = ({ accessLevel, navVariant = 'compact' }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigateToForm = useCallback((search, options) => {
    navigate({ pathname: PUBLIC_FORMS_PATH, search }, options);
  }, [navigate]);
  if (!canAccessPublicForms(accessLevel)) {
    return <Navigate to={publicFormsFallbackPath(accessLevel)} replace />;
  }

  return <PublicForms accessLevel={accessLevel} navVariant={navVariant} locationSearch={location.search} onNavigate={navigateToForm} />;
};

export default PublicFormsRoute;
